import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VersionCheckService } from '../../services/version-check/version-check.service';

/**
 * Renders a full-width banner directly under the navbar when `VersionCheckService` detects a
 * newly deployed version, prompting the user to reload or dismiss.
 */
@Component({
  selector: 'app-version-check-banner',
  standalone: true,
  imports: [AsyncPipe, MatButtonModule, MatIconModule],
  templateUrl: './version-check-banner.component.html',
  styleUrl: './version-check-banner.component.css',
})
export class VersionCheckBannerComponent {
  protected versionCheckService = inject(VersionCheckService);
}
